import { connect } from 'react-redux'
import * as action from '../../state/image/action'
import * as selector from '../../state/image/selector'
import * as customerSelector from '../../state/detail/selector'
import VersionedImageList from '../image/VersionedImageList'
import { selectCanSeeImages } from '../../../security/state/auth/selector'


const mapStateToProps = (state, props) => {
    return {
        customerId: customerSelector.selectCustomerId(state),
        canSeeImages: selectCanSeeImages(state),
        imageVersionList: selector.selectOrderedImageVersionList(state),
        showImages: selector.selectShowImages(state),
    }
}

const mapDispatchToProps = {
    findImageVersion: action.findImageVersion,
    uploadCustomerImage: action.uploadCustomerImage,
    rotateCustomerImage: action.rotateCustomerImage,
    toggleImageView: action.toggleImageView,
    setImageTypeMetaData: action.setImageTypeMetaData,
}

export default connect(mapStateToProps, mapDispatchToProps)(VersionedImageList)



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/CustomerImageWidgetContainer.js